import { supabase } from '@/lib/supabase'
import { SAMPLE_FAQS } from '../sample'

export type Faq = {
  id: string
  title: string
  content: string
  visible?: boolean | null
  position?: number | null
  created_at?: string
}

export async function listPublicFaqs(limit?: number): Promise<Faq[]> {
  try {
    let q = supabase
      .from('faqs')
      .select('id, title, content, position')
      .eq('visible', true)
      .order('position', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: true }) as any
    if (typeof limit === 'number' && limit > 0) q = q.limit(limit)
    const { data, error } = await q
    if (error) throw error
    return (data as any[]) as Faq[]
  } catch (e: any) {
    if (String(e?.message || '').includes('schema cache') || String(e?.message || '').includes('42P01')) {
      return typeof limit === 'number' ? SAMPLE_FAQS.slice(0, limit) : SAMPLE_FAQS
    }
    throw e
  }
}

export async function listAllFaqs(): Promise<Faq[]> {
  try {
    const { data, error } = await supabase
      .from('faqs')
      .select('*')
      .order('position', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: true })
    if (error) throw error
    return (data as any[]) as Faq[]
  } catch (e: any) {
    if (String(e?.message || '').includes('schema cache') || String(e?.message || '').includes('42P01')) {
      return SAMPLE_FAQS
    }
    throw e
  }
}

function isUuid(v?: string | null): boolean {
  if (!v) return false
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(v)
}

export async function upsertFaq(payload: Partial<Faq> & { title: string; content: string }): Promise<{ id: string }>{
  const body: any = { ...payload }
  if (!isUuid(body.id)) delete body.id
  if (typeof body.visible !== 'boolean') body.visible = true
  const { data, error } = await supabase.from('faqs').upsert(body, { onConflict: 'id' }).select('id').single()
  if (error) throw error
  return { id: (data as any).id as string }
}

export async function deleteFaq(id: string): Promise<void> {
  const { error } = await supabase.from('faqs').delete().eq('id', id)
  if (error) throw error
}
